import { AUSTRALIAN_AIRPORT_CODES } from '~/consts/australianAirports';

interface FlightSegment {
  departureAirport?: string;
  arrivalAirport?: string;
}

interface FlightLeg {
  segments?: Array<FlightSegment>;
}

/**
 * Returns true only when every segment in every leg has both Departure Airport and
 * Arrival Airport filled, and every value is in the Australian airports list (file-based).
 * Empty fields are treated as "not in list" so the checkbox is not checked until all are valid.
 */
export function areAllFlightAirportsGstApplicable(
  flightLegs: Array<FlightLeg> | undefined,
  airportCodes: ReadonlySet<string> = AUSTRALIAN_AIRPORT_CODES,
): boolean {
  if (!flightLegs?.length) {
    return false;
  }
  for (const leg of flightLegs) {
    for (const seg of leg.segments ?? []) {
      const dep = (seg.departureAirport ?? '').trim().toUpperCase();
      const arr = (seg.arrivalAirport ?? '').trim().toUpperCase();
      if (!dep || !arr) {
        return false;
      }

      if (!airportCodes.has(dep) || !airportCodes.has(arr)) {
        return false;
      }
    }
  }
  return true;
}
